const EditEntry = () => (
  <>
    <path
      fill="currentColor"
      d="M7 4.5A2.5 2.5 0 0 0 4.5 7v10A2.5 2.5 0 0 0 7 19.5h10a2.5 2.5 0 0 0 2.5-2.5v-6.5a.5.5 0 1 0-1 0V17a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 17V7A1.5 1.5 0 0 1 7 5.5h6.5a.5.5 0 0 0 0-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.066 4.184a.5.5 0 0 0-.707 0l-6.964 6.964-.177.884.884-.177 6.964-6.964a.5.5 0 0 0 0-.707m-1.414-.707a1.5 1.5 0 1 1 2.121 2.121l-7.178 7.178-1.549.31a.75.75 0 0 1-.882-.882l.31-1.549z"
      clipRule="evenodd"
    />
  </>
)
export default EditEntry
